import { type ComponentProps, type ReactNode } from 'react';

import { cn } from '../cn';
import { ESC_PRIORITY, useEscStack } from '../contexts';
import Button from '../Input2/Button';
import { General } from '../StrokeIcons';
import { Kbd } from '../Kbd';

export type DetailHeaderProps = ComponentProps<'div'> & {
  buttons?: ReactNode;
  footer?: ReactNode;
  isPaused?: boolean;
  /** Pass onClose to show close button and wire up ESC, omit to disable both */
  onClose?: () => void;
  /** Hide the close button while keeping ESC wired to onClose */
  hideCloseButton?: boolean;
};

export default function DetailHeader({
  children,
  buttons,
  footer,
  isPaused,
  onClose,
  hideCloseButton,
  ...props
}: DetailHeaderProps) {
  useEscStack('DetailHeader', ESC_PRIORITY.MED, onClose);

  return (
    <div
      className={cn('relative flex flex-col border-b overflow-hidden border-slate-200 dark:border-slate-700', {
        'border-none': footer,
      })}
      {...props}>
      <div
        className={cn('absolute left-0 right-0 top-0 h-0 bg-[#653896] transition-all dark:bg-[#6969c3]', {
          'h-1.5': isPaused,
        })}
      />
      <div className="relative flex shrink-0 items-center justify-between px-4 py-3 min-w-0">
        <div className="flex-1 min-w-0">{children}</div>
        <div className="flex items-center self-start justify-center shrink-0">
          {buttons}
          {onClose && !hideCloseButton && (
            <Button text icon={<General.XMark />} onClick={onClose} tooltip={<span>Close <Kbd>ESC</Kbd></span>} />
          )}
        </div>
      </div>
      {footer}
    </div>
  );
}
